export enum CommonConstant {
    FP_THONG_KE = "Thống kê",
    FP_FORM_REGISTER = "Đăng ký",
    FP_FORM_DYNAMIC = "Biểu mẫu đăng ký",
    FP_USER_CLBCV_MNG = "Phật tử CLB Cúc Vàng",
    FP_USER_CLBTT_MNG = "Phật tử CLB Tuổi Trẻ" ,
    FP_USER_CLBLHL_MNG = "Khóa sinh La Hầu La" ,
    FP_PHAN_QUYEN = "Phân quyền (Quản trị web)" ,

    ITEMS_PER_PAGE = "Số hàng mỗi trang",

    //Token 
    CURRENT_TOKEN = "CLB-Cuc-Vang-Token",
    CURRENT_USER = "CLB-Cuc-Vang-User",
    CURRENT_USER_PERMISSIONS = "CLB-Cuc-Vang-User-Permission",
    TEMPLATE_IMPORT_CLB_LHL = "Mẫu_Nhập_Khóa_Sinh_La_Hầu_La.xlsx",
    TEMPLATE_IMPORT_KHOI_LHL = "Mẫu_Nhập_Khóa_Sinh_La_Hầu_La(Khối).xlsx",
    TEMPLATE_IMPORT_KHOI_LOP_LHL = "Mẫu_Nhập_Khóa_Sinh_La_Hầu_La(Khối Lớp).xlsx",
    TEMPLATE_IMPORT_CLB_TT = "Mẫu_Nhập_CLB_Tuổi_Trẻ.xlsx",

}
// Thành phần Phật tử
export const THANH_PHAN_KHOA_SINH = [
  { value: 'CHÍNH THỨC', label: 'CHÍNH THỨC' },
  { value: 'GIEO DUYÊN', label: 'GIEO DUYÊN' }
];

// Thành phần Phật tử
export const CHUC_DANH_TAI_KHOI = [
  { value: 'LĐ Khối', label: 'LĐ Khối' },
  { value: 'CS Khối', label: 'CS Khối' },
  { value: 'Phát tâm Bồ đề (A)', label: 'Phát tâm Bồ đề (A)' },
  { value: 'Tin nhân quả (B)', label: 'Tin nhân quả (B)' },
  { value: 'Tìm hiểu Phật Pháp (C)', label:'Tìm hiểu Phật Pháp (C)' },
  { value:  'Gieo duyên Phật Pháp (D)', label:  'Gieo duyên Phật Pháp (D)'}
];

// Khóa sinh thuộc diện?
export const KHOA_SINH_THUOC_DIEN = [
  { value: 'Không mồ côi', label: 'Không mồ côi' },
  { value: 'Mồ côi mẹ', label: 'Mồ côi mẹ' },
  { value: 'Mồ côi bố', label: 'Mồ côi bố' },
  { value: 'Mồ côi cả bố và mẹ', label: 'Mồ côi cả bố và mẹ' },
  { value: 'Bố mẹ ly thân', label: 'Bố mẹ ly thân' },
  { value: 'Bố mẹ đã ly hôn', label: 'Bố mẹ đã ly hôn' },
  { value: 'Sinh ra không biết bố/mẹ là ai', label: 'Sinh ra không biết bố/mẹ là ai' },
  { value: 'Bố/mẹ bỏ đi từ nhỏ', label: 'Bố/mẹ bỏ đi từ nhỏ' }
];

// Gia đình có thuộc diện khó khăn hay không?
export const GD_KHO_KHAN = [
  { value: 'Không khó khăn', label: 'Không khó khăn' },
  { value: 'Khó khăn (Có chứng nhận hộ nghèo/cận nghèo)', label: 'Khó khăn (Có chứng nhận hộ nghèo/cận nghèo)' },
  { value: 'Hoàn cảnh khó khăn (Chưa có chứng nhận)', label: 'Hoàn cảnh khó khăn (Chưa có chứng nhận)' }
];
export const THANH_PHAN_BO_ME_KHOA_SINH = [
'Phật tử thành phần A',
'Phật tử thành phần B',
'Phật tử thành phần C',
'Phật tử thành phần D',
'Anh chị em của vợ của Phật tử',
'Con của Phật tử thành phần A/B/C (Ông bà của khóa sinh là Phật tử)',
'Cô/chú/dì/.... của Phật tử A/B/C',
'Anh chị em của chồng Phật tử'
];
export const LOP_HIEN_TAI_O_TRUONG = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];

export const THANG = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];

export const CHUC_NGAY_MOI_AN_LANH = [
    'Chúc luôn',
    'Chúc muộn'    
];

export const TRANG_THAI_TU_GIAC = [
    'TỰ GIÁC',
    'CHƯA TỰ GIÁC'    
];

export const VAI_TRO_BPT_KHOI_LHL = [
  { value: 'Trưởng khối', label: 'Trưởng khối' },
  { value: 'Phó khối', label: 'Phó khối' },
   { value: 'Thành viên khối', label: 'Thành viên khối' }
];

export const VAI_TRO_BPT_KHOI_LHL_FOR_KHOI = [
  { value: 'Phó khối', label: 'Phó khối' },
   { value: 'Thành viên khối', label: 'Thành viên khối' }
];
export const VAI_TRO_BCN_KHOI_LOP_LHL = [
  { value: 'Chủ nhiệm lớp', label: 'Chủ nhiệm lớp' },
  { value: 'Phó chủ nhiệm lớp', label: 'Phó chủ nhiệm lớp' },
   { value: 'Thành viên chủ nhiệm lớp', label: 'Thành viên chủ nhiệm lớp' }
];

export const VAI_TRO_BCN_KHOI_LOP_LHL_FOR_LOP = [
  { value: 'Phó chủ nhiệm lớp', label: 'Phó chủ nhiệm lớp' },
   { value: 'Thành viên chủ nhiệm lớp', label: 'Thành viên chủ nhiệm lớp' }
];

export enum KHOI_LHL {
    KHOI_1 = "KHỐI 1",
    KHOI_2 = "KHỐI 2",
    KHOI_3 = "KHỐI 3",
    KHOI_4 = "KHỐI 4",
}

// Thành phần Phật tử
export enum THANH_PHAN_KHOA_SINH_VALUE {
  CHINH_THUC = 'CHÍNH THỨC',
  GIEO_DUYEN = 'GIEO DUYÊN',
  CHUA_XAC_DINH = 'CHƯA XÁC ĐỊNH',
};

export const XEP_LOAI_OPTIONS = [
  { value: 'Xuất Sắc', label: 'Xuất Sắc' },
  { value: 'Giỏi', label: 'Giỏi' },
  { value: 'Khá', label: 'Khá' },
  { value: 'Cần cố gắng', label: 'Cần cố gắng' },
  { value: 'Không xếp loại', label: 'Không xếp loại' },
];

export const TU_GIAC_OPTIONS = [
  { value: 'Tự giác', label: 'Tự giác' },
  { value: 'Chưa tự giác', label: 'Chưa tự giác' },
];

export enum KS_LHL_TEMP_STATUS {
  DA_DANG_KY = 'Đã đăng ký', 
  DA_TIEP_NHAN = 'Đã tiếp nhận', 
  CAN_CHINH_SUA = 'Cần chỉnh sửa',
  DA_CHINH_SUA = 'Đã chỉnh sửa',
  CHUA_DU_DK_TIEP_NHAN = 'Khóa sinh chưa đủ điều kiện để tiếp nhận'
}
export const COMMON_PHONE_REGEX = /^\+?\d{7,15}$/;